export default {
	PLAYING: 'PLAYING',
	PAUSE: 'PAUSE',
	STOPPED: 'STOPPED',
};
